import { enableProdMode, ViewEncapsulation, provideZoneChangeDetection } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser';
import { AppModule } from 'app/app.module';
import { environment } from 'environments/environment';

if (environment.production) {
  enableProdMode();
}

const bootstrap = () =>
  platformBrowser().bootstrapModule(AppModule, {
    applicationProviders: [provideZoneChangeDetection()],
    // ViewEncapsulation.Emulated is the historical default for this app.
    defaultEncapsulation: ViewEncapsulation.Emulated,
  });

bootstrap().catch((err) => console.error(err));
